











import { Vue, Component, Prop, Ref, Inject } from 'vue-property-decorator'
import { GridDef, GridOptions, GridColumn } from '../../type'

@Component({
  components: {
    'form-control': () => import('../index.vue')
  }
})
export default class GridControl extends Vue {
  @Prop() def!: GridDef

  @Inject() exists!: (row: any, rowForm?: Record<string, any>) => boolean

  @Inject({ default: () => () => null }) getRowForm!: () => Record<string, any>

  get rowForm () {
    return this.getRowForm()
  }

  get columns (): GridColumn[] {
    return this.def?.columns || []
  }

  get options (): GridOptions {
    return Object.assign(new GridOptions(), this.def?.options || {})
  }
}
